<template>
  <div class="relative wwo flex-container ai-center d-flex flex-column">
    <div v-if="isMobile" class="mobile-top-nav header-2">What We Offer</div>
    <div v-if="!isMobile" class="mg-150" />
    <div v-if="isMobile" class="mg-55" />
    <div
      class="section-wrapper d-flex flex-column"
      v-bind:class="{ 'mg-150': !isMobile }"
    >
      <div v-if="!isMobile" class="header-2">What We Offer</div>
      <div v-if="!isMobile" class="text-1 mg-50 opaque">
        데이터몬스터즈의 데이터 센트릭 애널리틱스는
        <br />불확실성을 최소화하고, 복잡한 문제를 쉽게 해결하며, <br />의사결정
        효율성을 극대화시키는 분석방법론입니다.
        <br />
        <br />각종 자연·문화·사회·경제현상을 데이터 관점에서 재해석하기 위한
        니즈에 맞추어 <br />타겟 도메인으로부터 가치있는 인사이트를 도출할 수
        있도록 도와드리겠습니다.
      </div>

      <div
        class="flex-container jc-center"
        v-bind:class="{ 'd-flex flex-column': isMobile, 'mg-150': !isMobile }"
      >
        <p v-if="!isMobile" class="header-2 wwo-subtitle">
          Fundamental
          <br />Technologies
        </p>
        <div class="tech tech-01" v-bind:class="{ 'ml-auto': !isMobile }">
          <div class="tech-body flex-container d-flex flex-column">
            <p class="text-1">
              데이터 가공
              <br />
              <b>Processing & Engineering</b>
            </p>
            <div v-if="!isMobile" class="flex-container text-3 keep-all">
              <ul>
                <li>텍스트 데이터</li>
                <li>IoT/센서</li>
                <li>이미지 데이터</li>
                <li>수치/시계열</li>
                <li>위치기반 데이터</li>
              </ul>
              <ul>
                <li>자연어 처리</li>
                <li>데이터 디지털 신호 처리</li>
                <li>디지털 영상 처리</li>
                <li>데이터 벡터/행렬 연산</li>
                <li>공간정보 처리</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="tech tech-02">
          <div class="tech-body flex-container d-flex flex-column">
            <p class="text-1">
              데이터 분석 및 모델링
              <br />
              <b>Analysis & Modeling</b>
            </p>
            <div v-if="!isMobile" class="flex-container text-3 keep-all">
              <ul class="flex-1">
                <li>텍스트 마이닝</li>
                <li>네트워크 분석</li>
                <li>이상징후 탐지</li>
              </ul>
              <ul class="flex-1">
                <li>감성/담화/토픽 분석</li>
                <li>시계열/주기 분석</li>
                <li>기술 / 예측 / 처방 / 메타 분석</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="tech tech-03">
          <div class="tech-body flex-container d-flex flex-column">
            <p class="text-1">
              데이터 자산화 및 제품화
              <br />
              <b>Captialization & Productization</b>
            </p>
            <div v-if="!isMobile" class="flex-container text-3 keep-all">
              <ul class="flex-1">
                <li>Open API 구축</li>
                <li>데이터 기반 연구 수행</li>
                <li>연구/정책보고서 발간</li>
              </ul>
              <ul class="flex-1">
                <li>데이터 애널리틱스 시스템 구축</li>
                <li>웹 애플리케이션 구축</li>
                <li>데이터 시각화</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!isMobile" class="mg-150" />
    </div>
    <div class="relative bg-dark flex-container ai-center d-flex flex-column">
      <div class="section-wrapper d-flex flex-column mg-150">
        <p class="header-2 bold color-white">Technology Map</p>
        <div class="header-mask" />
        <div class="mg-50 flex-container d-flex flex-column">
          <div class="flex-container ai-center">
            <div
              class="header-cell center color-white text-2"
              v-bind:class="{ 'text-4': isMobile }"
            >
              원천데이터 수집
              <br />/ 적재기술
            </div>
            <div class="header-icon">+</div>
            <div
              class="header-cell center color-white text-2"
              v-bind:class="{ 'text-4': isMobile }"
            >
              가공기술
            </div>
            <div class="header-icon">·</div>
            <div
              class="header-cell center color-white text-2"
              v-bind:class="{ 'text-4': isMobile }"
            >
              분석ㆍ설계기술
            </div>
            <div class="header-icon">=</div>
            <div
              class="header-cell center color-white text-2"
              v-bind:class="{ 'text-4': isMobile }"
            >
              산출물
            </div>
            <div class="header-icon">></div>
            <div
              class="header-cell center color-white text-2"
              v-bind:class="{ 'text-4': isMobile }"
            >
              활용처
            </div>
          </div>
          <div class="flex-container mg-50">
            <div class="content-wrap">
              <div class="content-cell highlight">
                유형별
                <br />비정형/스트리밍/대용량
              </div>
              <div class="content-cell">자연어 텍스트</div>
              <div class="content-cell">영상/이미지</div>
              <div class="content-cell">IOT/센서 데이터</div>
              <div class="content-cell">수치/시계열 데이터</div>
              <div class="content-cell">GIS/GPS 공간데이터</div>
              <div class="content-cell highlight">
                원천별
                <br />공공/민간 데이터
              </div>
              <div class="content-cell">SNS/커뮤니티</div>
              <div class="content-cell">보건 / 의료 데이터</div>
              <div class="content-cell">기상 / 기후 데이터</div>
              <div class="content-cell">식품 / 유통 데이터</div>
              <div class="content-cell">조선 / 해양 데이터</div>
              <div class="content-cell">스마트 팩토리 / 스마트 시티</div>
              <div class="content-cell">기술 / 특허 데이터</div>
              <div class="content-cell">브랜드 / 쇼핑 데이터</div>
              <div class="content-cell last" />
            </div>
            <div class="content-spacer" />
            <div class="content-wrap">
              <div class="content-cell highlight">데이터 정제 / 여과</div>
              <div class="content-cell">데이터 필터링</div>
              <div class="content-cell">QA 및 테스팅</div>
              <div class="content-cell">자연어처리 / 개체명인식</div>
              <div class="content-cell highlight">데이터 변환</div>
              <div class="content-cell">데이터 연계 / 통합</div>
              <div class="content-cell">파싱 / 정보추출</div>
              <div class="content-cell">이미지 경계인식 / 분류</div>
              <div class="content-cell">데이터 비식별화</div>
              <div class="content-cell highlight">데이터 구축</div>
              <div class="content-cell">데이터 태깅</div>
              <div class="content-cell">온톨로지 / 택소노미 구축</div>
              <div class="content-cell highlight">데이터 시각화</div>
              <div class="content-cell">데이터 구조화</div>
              <div class="content-cell">
                그래프 / 차트 /
                <br />인포그래픽 생성
              </div>
              <div class="content-cell last" />
            </div>
            <div class="content-spacer" />
            <div class="content-wrap">
              <div class="content-cell highlight">AI 기반 분석기술</div>
              <div class="content-cell">감성 / 담화 / 토픽분석</div>
              <div class="content-cell">네트워크 분석</div>
              <div class="content-cell">시계열 / 주기분석</div>
              <div class="content-cell">패턴 / 트렌드 분석</div>
              <div class="content-cell">이상징후 탐지</div>
              <div class="content-cell highlight">기계학습 모델 구축</div>
              <div class="content-cell">기술 / 예측 분석 모델</div>
              <div class="content-cell">처방 / 메타 분석 모델</div>
              <div class="content-cell">딥애널리틱스</div>
              <div class="content-cell highlight">
                데이터 아키택쳐 /
                <br />연구설계 기술
              </div>
              <div class="content-cell">UI / UX / 인터랙션 설계</div>
              <div class="content-cell">학술연구 설계</div>
              <div class="content-cell">클러스터 / 게이트웨이 설계</div>
              <div class="content-cell">
                데이터 스토리지 /
                <br />파이프라인 설계
              </div>
              <div class="content-cell last" />
            </div>
            <div class="content-spacer" />
            <div class="content-wrap">
              <div class="content-cell highlight">데이터 자산화</div>
              <div class="content-cell">배포 / 판매용 데이터</div>
              <div class="content-cell">AI 학습용 데이터</div>
              <div class="content-cell">API설계 및 구축</div>
              <div class="content-cell">분석 보고서</div>
              <div class="content-cell highlight">데이터 제품화</div>
              <div class="content-cell">
                데이터플랫폼 /
                <br />큐레이션 서비스
              </div>
              <div class="content-cell">대시보드 / 애널리틱스</div>
              <div class="content-cell">모바일 / 웹 애플리케이션</div>
              <div class="content-cell">상호작용형 시각화 서비스</div>
              <div class="content-cell">검색엔진</div>
              <div class="content-cell last" />
            </div>
            <div class="content-spacer" />
            <div class="content-wrap">
              <div class="content-cell highlight">
                기업
                <br />데이터 기반 의사결정
              </div>
              <div class="content-cell">빅데이터 도입 전략 수립</div>
              <div class="content-cell">수요 / 매출 예측</div>
              <div class="content-cell">소비자 조사 / 신제품 기획</div>
              <div class="content-cell">데이터 마켓 운용</div>
              <div class="content-cell highlight">
                자지체 / 국책연
                <br />데이터 기반 정책제언
              </div>
              <div class="content-cell">시민 의견 수렴</div>
              <div class="content-cell">연구 / 정책보고서 발간</div>
              <div class="content-cell">공공 서비스 기획</div>
              <div class="content-cell highlight">
                공통
                <br />지원관리 및 모니터링
              </div>
              <div class="content-cell">
                데이터 애널릭틱스
                <br />시스템 구축
              </div>
              <div class="content-cell">
                모바일 /
                <br />웹 어플리케이션 구축
              </div>
              <div class="content-cell">Open API구축</div>
              <div class="content-cell">스마트 팩토리 / 그리드 운용</div>
              <div class="content-cell last" />
            </div>
          </div>
          <div v-if="!isMobile" class="mg-150" />
          <div v-if="isMobile" class="mg-50" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isMobile() {
      return window.innerWidth < 1000;
    },
  },
};
</script>

<style scoped>
.wwo-subtitle {
  font-size: 30px;
}
.tech {
  -ms-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  max-width: 250px;
  height: 620px;
  filter: grayscale(100%);
  transition: 0.3s ease-in-out;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  align-items: flex-end;
  color: lightgrey;
}

.tech:hover {
  filter: none;
  color: white;
  transition: 0.3s ease-in-out;
}

.tech-01 {
  background: url("../assets/wwo_bn_on01.jpg") no-repeat center center;
  background-size: cover;
}

.tech-02 {
  background: url("../assets/wwo_bn_on02.jpg") no-repeat center center;
  background-size: cover;
}

.tech-03 {
  background: url("../assets/wwo_bn_on03.jpg") no-repeat center center;
  background-size: cover;
}

.tech-body {
  background-color: rgba(1, 1, 1, 0.5);
  padding: 12px;
  word-break: keep-all;
  min-height: 220px;
}

.header-mask {
  width: 200%;
  height: 64px;
  background: #333;
  display: block;
  position: absolute;
  top: 268px;
  left: 50%;
  z-index: -1;
  content: "";
  margin-left: -100%;
}

.header-cell {
  height: 64px;
  -ms-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  border: 1px solid white;
  text-align: center;
}

.header-icon {
  height: 64px;
  width: 64px;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: bolder;
  font-size: 16px;
}

.content-wrap {
  -ms-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
}

.content-cell {
  width: 100%;
  height: 64px;
  color: white;
  font-size: 14px;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-left: 1px solid #4f4f4f;
  border-right: 1px solid #4f4f4f;
}

.highlight {
  background: #263646;
  border-left: 1px solid #6790bc;
  border-right: 1px solid #6790bc;
}

.last {
  border: none;
  background: url("../assets/wwosecbg.jpg") no-repeat center;
  background-size: cover;
}

.content-spacer {
  width: 64px;
  height: 100%;
}

@media only screen and (max-width: 880px) {
  .wwo {
    overflow-y: hidden;
  }

  .tech {
    width: 100vw;
    height: 200px;
    margin-left: calc((300px - 100vw) / 2);
    filter: none;
    max-width: none;
    transition: none;
  }

  .tech-01 {
    background: url("../assets/wwo_bn_mov01.jpg") no-repeat center center;
    background-size: cover;
  }

  .tech-02 {
    background: url("../assets/wwo_bn_mov02.jpg") no-repeat center center;
    background-size: cover;
  }

  .tech-03 {
    background: url("../assets/wwo_bn_mov03.jpg") no-repeat center center;
    background-size: cover;
  }

  .header-cell {
    height: 48px;
    width: 48px;
  }

  .header-mask {
    height: 48px;
    top: 220px;
  }

  .header-icon {
    height: 16px;
    width: 16px;
  }

  .content-cell {
    width: 48px;
    font-size: 6px;
    word-break: keep-all;
    min-height: fit-content;
    padding: 4px;
  }
  .tech-body {
    background: none;
    opacity: 1;
    color: white;
    justify-content: flex-end;
  }

  p {
    margin-bottom: 0 !important;
  }
}
</style>
